import React, { useState, useEffect, useRef } from "react";
import styles from "./MenuSection.module.css";
import { useNavigate } from "react-router-dom";
import { clearStorage, getStorageItem } from "../../Utils/storage";
import LogoutConfirmationPopup from "../LogoutConfirmationPopup";
import LeftArrowIcon from "../../Assests/Icons/LeftArrowIcon";
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowRight,
  MdOutlineLogout,
} from "react-icons/md";

const MenuSection = ({ isOpen, onClose, menuItems }) => {
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
  const navigate = useNavigate();
  const ownerData = getStorageItem("ownerData");
  const privileges = getStorageItem("privileges");
  const [filteredMenuItems, setFilteredMenuItems] = useState([]);

  const menuItemsRef = useRef(menuItems);
  const privilegesRef = useRef(privileges);
  menuItemsRef.current = menuItems;
  privilegesRef.current = privileges;
  const menuKey = (menuItems ?? []).map((item) => item.privilegeName).join("\n");
  const privilegeKey = Array.isArray(privileges) ? privileges.join("\n") : "";

  useEffect(() => {
    const currentPrivileges = privilegesRef.current;
    const currentMenu = menuItemsRef.current;
    if (!currentPrivileges || !currentMenu) return;
    setFilteredMenuItems(
      currentMenu.filter((item) => !item.privilegeName || currentPrivileges.includes(item.privilegeName))
    );
  }, [menuKey, privilegeKey]);

  const toggleSubmenu = (id) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.getElementById("sidebar");
      if (isOpen && sidebar && !sidebar.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleRedirection = (route, newTab) => {
    if (newTab) {
      window.open(route, "_blank", "noopener,noreferrer");
      onClose();
      return;
    }
    navigate(route);
    onClose();
  };

  const handleLogout = () => {
    setShowLogoutConfirmation(true);
  };

  const handleCancelLogout = () => {
    setShowLogoutConfirmation(false);
  };

  const handleConfirmLogout = () => {
    clearStorage();
    navigate("/login-email");
    setShowLogoutConfirmation(false);
  };

  return (
    <>
      {isOpen && <div className={styles.overlay} onClick={onClose}></div>}
      <div
        id="sidebar"
        className={`${styles.sidebar} ${isOpen ? styles.open : styles.collapsed
          }`}
      >
        <div className={`${styles.header} bg-[#0e76a8] mb-4`}>
          <p onClick={onClose} className={styles.headerStyles}>
            Hello! {ownerData?.realmName || "User"}
            <span className={styles.icon}>
              <LeftArrowIcon />
            </span>
          </p>
        </div>

        <ul className={styles.menu}>
          {filteredMenuItems?.map((item) => (
            <li key={item.id}>
              <div
                className={`flex items-center ${styles.menuItem}`}
                onClick={() =>
                  item?.submenu ? toggleSubmenu(item.id) : handleRedirection(item.route, item.newTab)
                }
              >
                {item.icon && <item.icon className={styles.iconMenuItem} />}
                <p className="ml-2">{item.label}</p>
                {item.submenu && (
                  <>
                    {openSubmenus[item.id] ? (
                      <MdKeyboardArrowRight className={`ml-2 ${styles.iconArrow}`} />
                    ) : (
                      <MdKeyboardArrowDown className={`ml-2 ${styles.iconArrow}`} />
                    )}
                  </>
                )}
              </div>
              {item.submenu && openSubmenus[item.id] && (
                <ul className={styles.submenu}>
                  {item.submenu.map((subItem) => (
                    <li
                      key={subItem.id}
                      onClick={() => handleRedirection(subItem.route)}
                      className="flex items-center"
                    >
                      {subItem.icon && <subItem.icon />}
                      <p className="ml-2">{subItem.label}</p>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
          <li>
            <div
              className={`${styles.menuItem} flex items-center`}
              onClick={handleLogout}
            >
              <MdOutlineLogout className={styles.iconMenuItem} />
              <p className="ml-2">Log out</p>
            </div>
          </li>
        </ul>
        {showLogoutConfirmation && (
          <LogoutConfirmationPopup
            onCancel={handleCancelLogout}
            onConfirm={handleConfirmLogout}
          />
        )}
      </div>
    </>
  );
};

export default MenuSection;